import React, { useMemo } from 'react';
import { toCssDeclarationName } from '@/features/editor/widgets/ai-component/inputs/shared/css-declarations';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { SingleSelectInput } from '@/features/editor/widgets/ai-component/inputs/shared/single-select-input';
import { DropdownInputOption } from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';

export interface CssEnumInputProps {
  name: string;
  initialValue?: string;
  onChange?: (name: string, value: string) => void;
  options?: DropdownInputOption[];
}

export function CssEnumInput({
  name,
  initialValue,
  options,
  onChange,
}: CssEnumInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);

  const initOption = useMemo(
    () => options?.find((option) => option.value === initialValue),
    [initialValue],
  );

  const onValueChanged = (value: DropdownInputOption) => {
    if (onChange) {
      onChange(name, value.value);
    }
  };

  return (
    <InlineInputCardWrapper>
      <span>{displayName}</span>
      <SingleSelectInput
        options={options}
        initialValue={initOption}
        onChange={onValueChanged}
      />
    </InlineInputCardWrapper>
  );
}
